import React, { useEffect, useState } from 'react'
import { Input } from '../../lib/components'
import { InvestorBankDetails } from '../../lib/types'
import './bank-details-form.scss'

interface BankDetailsFormProps {
  initialValues: InvestorBankDetails
}

export const BankDetailsForm = ({ initialValues }: BankDetailsFormProps) => {
  const [formValues, setFormValues] = useState<InvestorBankDetails>(initialValues)

  useEffect(() => {
    setFormValues(initialValues)
  }, [initialValues])

  return (
    <div className='bank-details-form' data-testid='bank-details-readonly'>
      <p className='bank-details-form__readonly-note' data-testid='bank-details-readonly-note'>
        Bank details are read-only and cannot be updated here. Please contact Credibila Support if a
        change is required.
      </p>
      <div className='form-grid'>
        <div className='form-field'>
          <Input
            labelText='Beneficiary Name'
            name='beneficiaryName'
            value={formValues.beneficiaryName || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
        <div className='form-field'>
          <Input
            labelText='Account Number'
            name='accountNumber'
            value={formValues.accountNumber || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
        <div className='form-field'>
          <Input
            labelText='Beneficiary Bank'
            name='beneficiaryBank'
            value={formValues.beneficiaryBank || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
        <div className='form-field'>
          <Input
            labelText='Bank Address'
            name='bankAddress'
            value={formValues.bankAddress || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
        <div className='form-field'>
          <Input
            labelText='CIF'
            name='cif'
            value={formValues.cif || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
        <div className='form-field'>
          <Input
            labelText='Swift Code'
            name='swiftCode'
            value={formValues.swiftCode || ''}
            handleChange={() => undefined}
            disabled
          />
        </div>
      </div>
    </div>
  )
}
